<template>
  <div v-if="section && section.blocks">
    <!-- Header -->
    <div class="team__header">
      <div class="team__left">
        <h1 class="alternative-page">
          <i class="signature">Our</i>
          <span class="outline" style="--text:'TEAM'">TEAM</span>
        </h1>
        <div
          class="rte"
          v-html="section.settings.content">
        </div>
      </div>
      <div class="team__right">
        <VImg :media="section.settings.team_image" alt="Team Image" />
        <small>{{ section.settings.image_footnote }}</small>
        <p>
          <i class="signature">
            {{ section.settings.team_summary }}
          </i>
        </p>
      </div>
    </div>

    <hr>

    <!-- Team Blocks -->
    <div class="team__blocks--wrapper">
      <header class="team__blocks-header">
        <h1>Our Team</h1>
        <p>Please, click on the cards to learn more.</p>
      </header>
      <div class="team__blocks">
        <div
          class="team-block"
          :class="{ 'active': idx == activePerson }"
          v-for="(person, idx) in team"
          @click="open(idx)"
          :key="person.id">
          <h5 class="team-block__label">{{ person.title }}</h5>
        </div>
      </div>
    </div>

    <!-- Person Modal -->
    <modal
      name="person"
      width="90%"
      height="85%"
      :maxWidth="850"
      :maxHeight="500"
      :adaptive="true"
      @before-close="activePerson = null">
      <div class="modal-person" v-if="team[activePerson]">
        <button
          class="vm--close"
          @click="close()">
        </button>
        <div class="modal-person__left">
          <h1>{{ team[activePerson].title }}</h1>
          <div v-html="team[activePerson].content"></div>
        </div>
        <div class="modal-person__right" v-if="team[activePerson].image.src">
          <VImg :media="team[activePerson].image" />
          <p>
            <small>{{ team[activePerson].title }}</small>
          </p>
        </div>
      </div>
    </modal>
  </div>
  <Loading
    v-else
    :activated="true"
  />
</template>

<script>
import VImg from './../components/VImg'
import Loading from './../components/Loading'

export default {
  name: 'Team',

  components: { VImg, Loading },

  props: [ 'page_content' ],

  computed: {
    team () {
      return this.section.blocks
    }
  },
  
  data () {
    return {
      section: null,
      activePerson: null
    }
  },

  mounted () {
    this.loadSection()
  },

  methods: {
    loadSection () {
      fetch(`/collections/all?view=team`)
        .then(res => res.json()).then(data => {
          if (data.length) {
            this.section = JSON.parse(data)
          }
        })
    },
    open (idx) {
      this.activePerson = idx
      this.$modal.show('person')
    },
    close () {
      this.$modal.hide('person')
    }
  }
}
</script>
